import moment from "moment";
import {
  TrenKunjunganHarian,
  TrenKunjunganPeriode,
  TrenKunjunganPuncak
} from "@/types/daftarRegisterPasien";

export const TREN_FORMAT = "YYYY-MM-DD";

export const TREN_MAKS_HARI = 366;

export function periodeHarian(hariIni: string): TrenKunjunganPeriode {
  return {
    start: moment(hariIni, TREN_FORMAT)
      .subtract(6, "days")
      .format(TREN_FORMAT),
    end: hariIni
  };
}

export function periodeBulanan(
  bulan: string,
  hariIni: string
): TrenKunjunganPeriode {
  const awal = moment(bulan, "YYYY-MM").startOf("month");
  const akhirBulan = awal
    .clone()
    .endOf("month")
    .format(TREN_FORMAT);
  const start = awal.format(TREN_FORMAT);
  const end = akhirBulan > hariIni ? hariIni : akhirBulan;

  return { start, end: end < start ? start : end };
}

export function periodeCustom(
  tanggal: string[],
  hariIni: string
): TrenKunjunganPeriode | null {
  if (tanggal.length !== 2) {
    return null;
  }

  const urut = tanggal.slice().sort();
  const end = urut[1] > hariIni ? hariIni : urut[1];

  return { start: urut[0] > end ? end : urut[0], end };
}

export function jumlahHari(periode: TrenKunjunganPeriode): number {
  return (
    moment(periode.end, TREN_FORMAT).diff(
      moment(periode.start, TREN_FORMAT),
      "days"
    ) + 1
  );
}

export function labelTanggalSumbu(tanggal: string, hariIni: string): string {
  const label = moment(tanggal, TREN_FORMAT).format("ddd, D MMM");

  return tanggal === hariIni ? `${label} (Hari ini)` : label;
}

export function labelPeriode(periode: TrenKunjunganPeriode): string {
  const format = "D MMMM YYYY";

  return `${moment(periode.start, TREN_FORMAT).format(format)} s/d ${moment(
    periode.end,
    TREN_FORMAT
  ).format(format)}`;
}

export function labelRentangSingkat(periode: TrenKunjunganPeriode): string {
  const format = "D MMM YYYY";

  return `${moment(periode.start, TREN_FORMAT).format(format)} - ${moment(
    periode.end,
    TREN_FORMAT
  ).format(format)}`;
}

export function totalHarian(hari: TrenKunjunganHarian): number {
  return hari.ralan + hari.igd + hari.ranap;
}

export function cariPuncak(
  harian: TrenKunjunganHarian[]
): TrenKunjunganPuncak | null {
  let puncak: TrenKunjunganPuncak | null = null;

  for (let i = 0; i < harian.length; i++) {
    const total = totalHarian(harian[i]);

    if (!puncak || total > puncak.total) {
      puncak = { tanggal: harian[i].tanggal, total };
    }
  }

  return puncak && puncak.total > 0 ? puncak : null;
}
